import React, { useContext } from 'react';

import TicketContext from '@totem/components/ticketing/details/ticketContext';
import HeaderItem from '@totem/components/ui_components/headers/HeaderItem';
import { isNotNull } from '@totem/utilities/common';

const styles = {
  container: {
    marginBottom: '16px',
  },
  text: {
    whiteSpace: 'pre-wrap' as const,
  },
};

// Shows the event configuration's customer-facing explanation (what the alert means,
// why a ticket was raised, and its impact) when the ticket has one -- older tickets, or
// ones not created from a matched event configuration, won't have this populated.
const CustomerExplanationPanel = () => {
  const { ticket } = useContext(TicketContext);

  const customerInfo = ticket?.ticket?.extras?.customerInfo;

  const hasContent =
    isNotNull(customerInfo) &&
    Boolean(
      customerInfo.whatItMeans ||
      customerInfo.whyTicketRaised ||
      customerInfo.impact,
    );

  if (!hasContent) {
    return null;
  }

  return (
    <div style={styles.container}>
      {customerInfo.whatItMeans && (
        <HeaderItem title="What It Means">
          <span style={styles.text}>{customerInfo.whatItMeans}</span>
        </HeaderItem>
      )}
      {customerInfo.whyTicketRaised && (
        <HeaderItem title="Why This Ticket Was Raised">
          <span style={styles.text}>{customerInfo.whyTicketRaised}</span>
        </HeaderItem>
      )}
      {customerInfo.impact && (
        <HeaderItem title="Impact">
          <span style={styles.text}>{customerInfo.impact}</span>
        </HeaderItem>
      )}
    </div>
  );
};

export default CustomerExplanationPanel;
